<template>
  <v-app-bar app clipped-left elevation="1" dense class="header" color="white">
    <v-app-bar-nav-icon
      v-on:click="toggle()"
      color="primary"
    ></v-app-bar-nav-icon>
    <v-spacer></v-spacer>

    <v-btn
      color="primary"
      class="ml-2"
      icon
      :href="this.helpUrl"
      target="_blank"
    >
      <v-icon>mdi-help</v-icon>
    </v-btn>
    <!--    <v-btn color="primary" class="ml-2" icon>-->
    <!--      <v-icon>mdi-bell</v-icon>-->
    <!--    </v-btn>-->
    <v-menu bottom left offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="primary" class="ml-2" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item to="/profile">
          <v-list-item-title>{{ $t("profile.profile") }}</v-list-item-title>
        </v-list-item>
        <v-list-item to="/logout">
          <v-list-item-title>{{ $t("logout.logout") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Header",
  methods: {
    toggle() {
      this.toggleRootNavigationNode({
        url: window.location.pathname + window.location.hash
      });
    },
    ...mapActions({
      toggleRootNavigationNode: "navigationStore/toggleRootNavigationNode"
    })
  },
  computed: {
    helpUrl() {
      const profile = this.$store.getters["profileStore/getProfile"];
      const lang = profile.language?.substr(0, 2) ?? null;

      if (["de"].includes(lang)) {
        return `https://docs.lexgate.ch/${lang}`;
      }

      return "https://docs.lexgate.ch";
    }
  }
};
</script>
